import Checkbox from "@mui/material/Checkbox";
import React from "react";
import Flex from "../../../../../../../components/Flex";

interface VisitNoteWithCheckBoxProps {
  hide?: boolean;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
}

/**
 *
 * @param checked - the checked state of the checkbox
 * @param onChange - the function to call when the checkbox is changed
 * @param children - the children to render
 *
 * @author [RajKumar Rathod]
 */
const VisitNoteWithCheckBox = ({
  hide,
  checked,
  onChange,
  children,
}: VisitNoteWithCheckBoxProps) => {
  return (
    <Flex gap={0.5}>
      {!hide && (
        <Checkbox checked={!!checked} onChange={onChange} size="small" />
      )}
      {children}
    </Flex>
  );
};

export default VisitNoteWithCheckBox;
